import { gql } from "@apollo/client";

export const saveUniformItemMutation = gql`
mutation($input: UniformItemInput!){
  saveUniformItem(input: $input){
    response
    message
  }
}
`;

export const archiveUniformItemMutation = gql`
mutation($id: String!, $archived: Boolean!){
  archiveUniformItem(id: $id, archived: $archived){
    response
    message
  }
}
`;

export const approveUniformRequestMutation = gql`
mutation($id: String!, $note: String){
  approveUniformRequest(id: $id, note: $note){
    response
    message
  }
}
`;

export const rejectUniformRequestMutation = gql`
mutation($id: String!, $note: String){
  rejectUniformRequest(id: $id, note: $note){
    response
    message
  }
}
`;

export const cancelUniformRequestMutation = gql`
mutation($id: String!, $note: String){
  cancelUniformRequest(id: $id, note: $note){
    response
    message
  }
}
`;

export const issueUniformRequestMutation = gql`
mutation($id: String!, $lines: [UniformLineInput!], $issuedDate: String, $note: String, $signature: String){
  issueUniformRequest(id: $id, lines: $lines, issuedDate: $issuedDate, note: $note, signature: $signature){
    response
    message
  }
}
`;

export const logUniformIssueMutation = gql`
mutation($input: UniformIssueInput!){
  logUniformIssue(input: $input){
    response
    message
  }
}
`;

export const deleteUniformIssueMutation = gql`
mutation($id: String!){
  deleteUniformIssue(id: $id){
    response
    message
  }
}
`;

export const saveUniformSizeListMutation = gql`
mutation($input: UniformSizeListInput!){
  saveUniformSizeList(input: $input){
    response
    message
  }
}
`;

export const archiveUniformSizeListMutation = gql`
mutation($id: String!, $archived: Boolean!){
  archiveUniformSizeList(id: $id, archived: $archived){
    response
    message
  }
}
`;

export const signUniformReceiptInPersonMutation = gql`
mutation($id: String!, $signature: String!){
  signUniformReceiptInPerson(id: $id, signature: $signature){
    response
    message
  }
}
`;

export const remindUniformReceiptMutation = gql`
mutation($id: String!){
  remindUniformReceipt(id: $id){
    response
    message
  }
}
`;

export const recordUniformReturnMutation = gql`
mutation($input: UniformReturnInput!){
  recordUniformReturn(input: $input){
    response
    message
  }
}
`;
